var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-row',{staticClass:"justify-content-center"},[_c('lottie-player',{staticStyle:{"width":"200px","height":"200px"},attrs:{"src":"https://assets7.lottiefiles.com/packages/lf20_ufvrktsf.json","background":"transparent","speed":"1","autoplay":"","loop":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }